export { default } from "./ApplicationTable";
export { default as ApplicationTable } from "./ApplicationTable";
